import numeral from 'numeral';
import React from 'react';
import { Link as RouteLink } from 'react-router-dom';
import { Cell } from "../CloudConversions/CloudConversionsTableData";
import ViewReportIcon from "../Common/ViewReportIcon";
export const TransactionsReportsHeader = {
  cells: [{
    key: 'saleDate',
    content: 'Sale date',
    style: {
      minWidth: '95px'
    }
  }, {
    key: 'orderId',
    content: 'Order ID',
    style: {
      minWidth: '120px'
    }
  }, {
    key: 'licenseId',
    content: 'License ID',
    style: {
      minWidth: '120px'
    }
  }, {
    key: 'customer',
    content: 'Customer'
  }, {
    key: 'app',
    content: 'App',
    style: {
      minWidth: '230px'
    }
  }, {
    key: 'saleType',
    content: 'Sale type',
    style: {
      minWidth: '80px'
    }
  }, {
    key: 'tier',
    content: 'Tier',
    style: {
      minWidth: '120px'
    }
  }, {
    key: 'net',
    content: 'Net $',
    style: {
      minWidth: '120px'
    }
  }]
};
export const getTransactionsReportsBody = (transactions, getReportsLink, onViewTransactionClick) => transactions.map(transaction => ({
  key: transaction.transactionId,
  cells: [{
    key: transaction.purchaseDetails.saleDate,
    content: /*#__PURE__*/React.createElement(Cell, null, transaction.purchaseDetails.saleDate)
  }, {
    key: transaction.transactionId,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('text', transaction.transactionId)
    }, transaction.transactionId)
  }, {
    key: transaction.licenseId,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('text', transaction.licenseId, 'licenseId')
    }, transaction.licenseId)
  }, {
    key: transaction.customerDetails.company,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('text', transaction.customerDetails.company)
    }, transaction.customerDetails.company)
  }, {
    key: transaction.addonName,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('addon', transaction.addonKey)
    }, transaction.addonName)
  }, {
    key: transaction.purchaseDetails.tier,
    content: /*#__PURE__*/React.createElement(RouteLink, {
      to: getReportsLink('saleType', transaction.purchaseDetails.saleType.toLowerCase())
    }, transaction.purchaseDetails.saleType)
  }, {
    key: transaction.purchaseDetails.tier,
    content: transaction.purchaseDetails.tier
  }, {
    key: transaction.purchaseDetails.vendorAmount,
    content: /*#__PURE__*/React.createElement(ViewReportIcon, {
      columnValue: numeral(transaction.purchaseDetails.vendorAmount).format('$0,0.00'),
      onClick: _ => onViewTransactionClick(transaction)
    })
  }]
}));